




































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ITreeData, IPpr, IMonthVal, IMonthTotal, ISelected } from "./treeTableData";
import CPopUp from "../CPopUp.vue";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import CReasonCell from "@/modules/budget/alteration/form/tabs/components/CreateForm/reasons/CReasonCell.vue";
import {
    IReasonGroup,
    ReasonPlanType,
    referenceReasonKey
} from "@/modules/budget/alteration/form/tabs/components/CreateForm/reasons/alteration-reason-api";

const monthLst = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

// Разрез "по АБП" для вкладки "Справки (расходы)" (tabCode='reference_expenses', tableType=2).
// В отличие от c-abp-gu-tree-table уровень ГУ в иерархии не используется: abp -> prg -> ppr -> spf(+проекты).
// Так как несколько исходных строк могут отличаться только по ГУ (который здесь не учитывается),
// одинаковые по (abp, prg, ppr, spf) строки необходимо схлопывать (суммировать суммы по месяцам и
// сливать child_list по expense_code) - паттерн слияния перенесён из CPrgTreeTable.vue.
// Колонка "Примечание" (EAK-808) - только просмотр причин, внесённых в консолидированных заявках АБП.
@Component({
    name: 'c-abp-prg-tree-table',
    components: {
        'c-pop-up': CPopUp,
        'c-reason-cell': CReasonCell
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        }
    }
})
export default class CAbpPrgTreeTable extends AlterationI18nMixin {
    @Prop({
        required: true,
        default: null
    })
    private tableData!: any;

    @Prop({
        required: true,
        default: []
    })
    private editedMonths!: number[]; // 0-11

    @Prop({
        required: true,
        default: []
    })
    private createdMonths!: number; // 0-11

    @Prop({
        required: true,
        default: null
    })
    private accessLevel!: any;

    @Prop({
        required: true,
        default: null
    })
    private uSumVisible!: number;

    // --- Колонка "Примечание" (причины отклонения консолидированных заявок АБП), только просмотр (EAK-808) ---
    @Prop({
        required: false,
        default: false
    })
    private reasonVisible!: boolean;

    // Ключ - referenceReasonKey (с кодом АБП: в справке несколько АБП)
    @Prop({
        required: false,
        default: () => ({})
    })
    private reasonGroups!: Record<string, IReasonGroup>;

    @Prop({
        required: false,
        default: 1
    })
    private reasonPlanType!: ReasonPlanType;

    private collapseAll = true;

    private selectedRow: ISelected | null = null;

    private treeData: ITreeData[] = [];

    private totalSum: IMonthTotal = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0, utochSum: 0, sum: 0 };

    private mounted() {
        this.getTreeData();
        this.$watch('tableData', () => {
            this.getTreeData();
        }, { deep: true });
        this.$watch('locale', () => {
            this.getTreeData();
        }, { deep: true });
    }

    private get editedArr() {
        const editedArr = [false, false, false, false, false, false, false, false, false, false, false, false];
        if (!this.accessLevel.editAccess) { return editedArr; }
        for (const el of this.editedMonths) {
            editedArr[el] = true;
        }
        return editedArr;
    }

    private getFlk4(el: any) { // проверка флк (аналогично c-abp-gu-tree-table - только на уровне СПФ, не по каждому проекту)
        for (let i=0; i<12; i++) {
            if (el[`month${i}`] + el[monthLst[i]] < 0) {
                if (!el.flk) { el.flk = {}; }
                if (!el.flk[`month${i}`]) { el.flk[`month${i}`] = []; }
                el.flk[`month${i}`].push({id: 4, typeErr: 'error', textErr: this.setText('flc.flc4')});
            }
        }
    }

    private getTreeData() {
        const treeData: any[] = [];
        this.totalSum = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0, utochSum: 0, sum: 0 };
        if (!this.tableData) {
            this.treeData = [];
            return;
        }

        // Глубокое клонирование - слияние одинаковых ПРГ/ППР/СПФ (из-за схлопывания уровня ГУ) не должно
        // мутировать исходные строки в this.tableData, т.к. они используются также разрезом "по ГУ".
        const tableData = JSON.parse(JSON.stringify(this.tableData));
        this.nameSet(tableData);
        for (let i = 0; i < tableData.length; i++) {
            tableData[i]._indxArr = i;
        }
        tableData.sort((a: any, b: any) => (a.abp > b.abp) ? 1 : -1);

        // 1. Группировка по АБП
        const mapAbp = new Map();
        for (const el of tableData) {
            let abpObj = mapAbp.get(el.abp);
            if (!abpObj) {
                abpObj = { abp: el.abp, abpName: el.abp_name, vals: [el] };
                mapAbp.set(el.abp, abpObj);
            } else {
                abpObj.vals.push(el);
            }
        }

        // 2. Группировка по программам внутри АБП
        for (const [keyAbp, valAbp] of mapAbp) {
            const mapPrg = new Map();
            for (const elPrg of valAbp.vals) {
                let prgObj = mapPrg.get(elPrg.prg);
                if (!prgObj) {
                    prgObj = { prg: elPrg.prg, prgName: elPrg.prg_name, vals: [elPrg] };
                    mapPrg.set(elPrg.prg, prgObj);
                } else {
                    prgObj.vals.push(elPrg);
                }
            }
            mapAbp.set(keyAbp, { ...valAbp, vals: mapPrg });
        }

        // 3. Группировка по подпрограммам внутри (АБП, ПРГ)
        for (const [, valAbp] of mapAbp) {
            for (const [keyPrg, valPrg] of valAbp.vals) {
                const mapPpr = new Map();
                for (const elPpr of valPrg.vals) {
                    let pprObj = mapPpr.get(elPpr.ppr);
                    if (!pprObj) {
                        pprObj = { ppr: elPpr.ppr, pprName: elPpr.ppr_name, vals: [elPpr] };
                        mapPpr.set(elPpr.ppr, pprObj);
                    } else {
                        pprObj.vals.push(elPpr);
                    }
                }
                valAbp.vals.set(keyPrg, { ...valPrg, vals: mapPpr });
            }
        }

        const totalSumTemplate: IMonthTotal = { month0: 0, month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0, month7: 0, month8: 0, month9: 0, month10: 0, month11: 0, utochSum: 0 };

        for (const [, valAbp] of mapAbp) {
            const objAbp: any = {
                abp: valAbp.abp,
                abpName: valAbp.abpName,
                vals: [],
                collapse: this.collapseAll,
                totalSum: Object.assign({}, totalSumTemplate)
            };

            for (const [, valPrg] of valAbp.vals) {
                const objPrg: any = {
                    prg: valPrg.prg,
                    prgName: valPrg.prgName,
                    vals: [],
                    totalSum: Object.assign({}, totalSumTemplate),
                    utochSum: 0,
                    collapse: this.collapseAll
                };

                for (const [, valPpr] of valPrg.vals) {
                    const objPpr: any = {
                        ppr: valPpr.ppr,
                        pprName: valPpr.pprName,
                        vals: [],
                        totalSum: Object.assign({}, totalSumTemplate),
                        utochSum: 0,
                        collapse: this.collapseAll
                    };

                    // Объединение одинаковых специфик (SPF) внутри (АБП, ПРГ, ППР).
                    // Дубликаты возникают, когда несколько исходных строк отличались только по ГУ,
                    // который в разрезе "по АБП" не учитывается при группировке.
                    // Паттерн слияния - см. CPrgTreeTable.vue ("Объединение одинаковых специфик внутри подпрограммы").
                    const spfMap = new Map();
                    for (const spfEl of valPpr.vals) {
                        if (!spfMap.has(spfEl.spf)) {
                            spfMap.set(spfEl.spf, spfEl);
                        } else {
                            const existingSpf = spfMap.get(spfEl.spf);
                            // Складываем запрашиваемые суммы
                            this.getSumTotal(existingSpf, spfEl);

                            // Складываем плановые значения (для корректной проверки ФЛК4)
                            for (const monthName of monthLst) {
                                existingSpf[monthName] = Math.round(((existingSpf[monthName] || 0) + (spfEl[monthName] || 0)) * 10) / 10;
                            }

                            // Слияние child_list (одинаковых расходов) по expense_code
                            if (spfEl.child_list && spfEl.child_list.length) {
                                if (!existingSpf.child_list) { existingSpf.child_list = []; }
                                for (const childEl of spfEl.child_list) {
                                    const existingChild = existingSpf.child_list.find((c: any) => c.expense_code === childEl.expense_code);
                                    if (existingChild) {
                                        this.getSumTotal(existingChild, childEl);
                                        for (const monthName of monthLst) {
                                            existingChild[monthName] = Math.round(((existingChild[monthName] || 0) + (childEl[monthName] || 0)) * 10) / 10;
                                        }
                                    } else {
                                        existingSpf.child_list.push(childEl);
                                    }
                                }
                            }
                        }
                    }

                    // Формирование итогового списка специфик для подпрограммы
                    for (const spfEl of spfMap.values()) {
                        // Проверка ФЛК выполняется на уже объединённых (суммированных) данных
                        this.getFlk4(spfEl);
                        if (spfEl.child_list && spfEl.child_list.length) {
                            spfEl.collapse = this.collapseAll;
                        }
                        this.getSumTotal(objPpr.totalSum, spfEl);
                        objPpr.vals.push(spfEl);
                    }

                    objPpr.vals.sort((a: any, b: any) => (a.spf - b.spf > 0 ? 1 : -1));
                    objPrg.vals.push(objPpr);
                    this.getSumTotal(objPrg.totalSum, objPpr.totalSum);
                }
                objPrg.vals.sort((a: any, b: any) => (a.ppr - b.ppr > 0 ? 1 : -1));
                objAbp.vals.push(objPrg);
                this.getSumTotal(objAbp.totalSum, objPrg.totalSum);
            }
            objAbp.vals.sort((a: any, b: any) => (a.prg - b.prg > 0 ? 1 : -1));
            treeData.push(objAbp);
            this.getSumTotal(this.totalSum, objAbp.totalSum);
        }

        this.totalSum.sum = this.getSum(this.totalSum);
        this.treeData = treeData;
    }

    private getSum(obj: any) {
        let sum = 0;
        for (let i=0; i < 12; i++) {
            if (obj[`month${i}`]) {
                sum = Math.round(((typeof obj[`month${i}`] == 'number' ? obj[`month${i}`] : parseFloat(obj[`month${i}`])) + sum)*10)/10;
            }
        }
        return sum;
    }

    private getSumTotal(total: any, obj: IMonthVal) {
        if (obj.month0) { total.month0 = Math.round(((typeof obj.month0 == 'number' ? obj.month0 : parseFloat(obj.month0)) + total.month0)*10)/10; }
        if (obj.month1) { total.month1 = Math.round(((typeof obj.month1 == 'number' ? obj.month1 : parseFloat(obj.month1)) + total.month1)*10)/10; }
        if (obj.month2) { total.month2 = Math.round(((typeof obj.month2 == 'number' ? obj.month2 : parseFloat(obj.month2)) + total.month2)*10)/10; }
        if (obj.month3) { total.month3 = Math.round(((typeof obj.month3 == 'number' ? obj.month3 : parseFloat(obj.month3)) + total.month3)*10)/10; }
        if (obj.month4) { total.month4 = Math.round(((typeof obj.month4 == 'number' ? obj.month4 : parseFloat(obj.month4)) + total.month4)*10)/10; }
        if (obj.month5) { total.month5 = Math.round(((typeof obj.month5 == 'number' ? obj.month5 : parseFloat(obj.month5)) + total.month5)*10)/10; }
        if (obj.month6) { total.month6 = Math.round(((typeof obj.month6 == 'number' ? obj.month6 : parseFloat(obj.month6)) + total.month6)*10)/10; }
        if (obj.month7) { total.month7 = Math.round(((typeof obj.month7 == 'number' ? obj.month7 : parseFloat(obj.month7)) + total.month7)*10)/10; }
        if (obj.month8) { total.month8 = Math.round(((typeof obj.month8 == 'number' ? obj.month8 : parseFloat(obj.month8)) + total.month8)*10)/10; }
        if (obj.month9) { total.month9 = Math.round(((typeof obj.month9 == 'number' ? obj.month9 : parseFloat(obj.month9)) + total.month9)*10)/10; }
        if (obj.month10) { total.month10 = Math.round(((typeof obj.month10 == 'number' ? obj.month10 : parseFloat(obj.month10)) + total.month10)*10)/10; }
        if (obj.month11) { total.month11 = Math.round(((typeof obj.month11 == 'number' ? obj.month11 : parseFloat(obj.month11)) + total.month11)*10)/10; }
        if (obj.utochSum) { total.utochSum = Math.round(((typeof obj.utochSum == 'number' ? obj.utochSum : parseFloat(obj.utochSum)) + total.utochSum)*10)/10; }
    }

    private clkCollapse(abpIndx: number | null, prgIndx: number | null, subIndx: number | null, spfIndx: number | null, collapse?: boolean) {
        if (abpIndx === null) {
            this.collapseAll = !this.collapseAll;
            for (const abpEl of this.treeData) {
                abpEl.collapse = this.collapseAll;
                for (const prgEl of abpEl.vals) {
                    prgEl.collapse = this.collapseAll;
                    for (const subEl of prgEl.vals) {
                        subEl.collapse = this.collapseAll;
                        for (const spfEl of subEl.vals) {
                            if (spfEl.collapse!==undefined) { spfEl.collapse = this.collapseAll; }
                        }
                    }
                }
            }
            return;
        }

        if (collapse ===undefined) { return; }

        if (prgIndx === null) {
            this.treeData[abpIndx].collapse = collapse;
            if (!collapse && this.collapseAll) { this.collapseAll = false; }
            if (collapse !== this.collapseAll) {
                let fl = false;
                for (let i = 0; i < this.treeData.length; i++) {
                    if (this.treeData[i].collapse !== collapse) {
                        fl = true;
                        break;
                    }
                }
                if (!fl) { this.collapseAll = collapse; }
            }
            for (const prgEl of this.treeData[abpIndx].vals) {
                prgEl.collapse = collapse;
                for (const subEl of prgEl.vals) {
                    subEl.collapse = collapse;
                    for (const spfEl of subEl.vals) {
                        if (spfEl.collapse!==undefined) { spfEl.collapse = collapse; }
                    }
                }
            }
        } else {
            if (subIndx === null) {
                this.treeData[abpIndx].vals[prgIndx].collapse = collapse;
                for (const subEl of this.treeData[abpIndx].vals[prgIndx].vals) {
                    subEl.collapse = collapse;
                    for (const spfEl of subEl.vals) {
                        if (spfEl.collapse!==undefined) { spfEl.collapse = collapse; }
                    }
                }
            } else {
                if (spfIndx === null) {
                    this.treeData[abpIndx].vals[prgIndx].vals[subIndx].collapse = collapse;
                    for (const spfEl of this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals) {
                        if (spfEl.collapse!==undefined) { spfEl.collapse = collapse; }
                    }
                } else {
                    if (this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals[spfIndx].collapse!==undefined) { this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals[spfIndx].collapse = collapse; }
                }
            }
        }
    }

    private selectRow(abpIndx: number, prgIndx: number, subIndx: number, spfIndx: number, formIndx: number | null){
        if (this.selectedRow) {
            const obj = this.getSelectedObj(this.selectedRow.abpIndx, this.selectedRow.prgIndx, this.selectedRow.subIndx, this.selectedRow.spfIndx, this.selectedRow.formIndx);
            if (obj) { obj.selectedRow = null; }
        }
        const obj = this.getSelectedObj(abpIndx, prgIndx, subIndx, spfIndx, formIndx);
        obj.selectedRow = true;
        const selectedRow = Object.assign({ abpIndx: abpIndx, prgIndx: prgIndx, subIndx: subIndx, spfIndx: spfIndx, formIndx: formIndx }, obj);
        let sum = 0;
        for (const monthName of monthLst) {
            sum += this.sumMonth(selectedRow, monthName);
        }
        selectedRow.sumMonth = Math.round(sum * 10) / 10;

        this.calcSumSelectedAndSpf(selectedRow);

        this.selectedRow = selectedRow;
    }

    private calcSumSelectedAndSpf(selectedRow: any) { // расчёт суммы планового значения и специфики (например january и month0)
        let sumMonthTmp = selectedRow.sumMonth;
        for (let i=0; i < 12; i++) {
            const obj = this.getSelectedObj(selectedRow.abpIndx, selectedRow.prgIndx, selectedRow.subIndx, selectedRow.spfIndx, selectedRow.formIndx);
            selectedRow[`${monthLst[i]}_tmp`] = Math.round((selectedRow[monthLst[i]] + obj[`month${i}`]) * 10) / 10;
            sumMonthTmp += obj[`month${i}`];
        }
        selectedRow.sumMonthTmp = Math.round(sumMonthTmp * 10)/10;
    }

    private sumMonth(monthObj: any, fieldName: string) {
        if (!monthObj[fieldName]) { monthObj[fieldName] = 0; }
         return monthObj[fieldName];
    }

    private getSelectedObj(abpIndx: number, prgIndx: number, subIndx: number, spfIndx: number, formIndx: number | null) {
        let obj: any = {};
        if (formIndx === null) {
            obj = this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals[spfIndx];
        } else {
            obj = this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals[spfIndx].child_list[formIndx];
        }
        return obj;
    }

    private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }

    private chgValue(spfObj: any, fieldName: string, chldIndx?: number) {
        let obj = spfObj;
        if (chldIndx !== undefined) { obj = spfObj.child_list[chldIndx]; }
        if (parseFloat(String(obj[fieldName])).isNaN) { obj[fieldName] = 0; }
        obj[fieldName] = parseInt((obj[fieldName] * 10).toString()) / 10;
        const tableData = JSON.parse(JSON.stringify(this.tableData));
        if (chldIndx !== undefined) {
            tableData[spfObj._indxArr].child_list[chldIndx][fieldName] = obj[fieldName];
        } else {
            tableData[spfObj._indxArr][fieldName] = obj[fieldName];
            if (obj[fieldName] === 0 && tableData[spfObj._indxArr].child_list) {
                for (const el of tableData[spfObj._indxArr].child_list) {
                    el[fieldName] = 0;
                }
            }
        }

        this.$emit('chgData', { tableData, indx: spfObj._indxArr, chldIndx: chldIndx, fieldName: fieldName });
    }

    // ------
    private async nextInput(monthIndx: number, abpIndx: number, prgIndx: number, subIndx: number, spfIndx: number, chldIndx: number | null = null) {
        let indxObj: any = { abpIndx, prgIndx, subIndx, spfIndx, chldIndx };
        if (chldIndx === null) {
            indxObj = this.getNextInputIndx(abpIndx, prgIndx, subIndx, spfIndx, chldIndx);
        } else {
            // @ts-ignore
            if (this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals[spfIndx].child_list.length - 1 > chldIndx) {
                if (indxObj.chldIndx!==null) { indxObj.chldIndx++; }
            } else {
                indxObj = this.getNextInputIndx(abpIndx, prgIndx, subIndx, spfIndx, chldIndx);
            }
        }

        let name = '';
        this.treeData[indxObj.abpIndx].vals[indxObj.prgIndx].collapse = false;
        this.treeData[indxObj.abpIndx].vals[indxObj.prgIndx].vals[indxObj.subIndx].collapse = false;
        if (indxObj.chldIndx === null) {
            name = `inp_${indxObj.abpIndx}_${indxObj.prgIndx}_${indxObj.subIndx}_${indxObj.spfIndx}_month${monthIndx}`;
        } else {
            name = `inp_${indxObj.abpIndx}_${indxObj.prgIndx}_${indxObj.subIndx}_${indxObj.spfIndx}_${indxObj.chldIndx}_month${monthIndx}`;
            this.treeData[indxObj.abpIndx].vals[indxObj.prgIndx].vals[indxObj.subIndx].vals[indxObj.spfIndx].collapse = false;
        }
        await this.$nextTick();
        // eslint-disable-next-line
        // @ts-ignore
        if (this.$refs[name]) { this.$refs[name][0].select(); }
        if (!(this.selectedRow && this.selectedRow.abpIndx === indxObj.abpIndx && this.selectedRow.prgIndx === indxObj.prgIndx && this.selectedRow.subIndx === indxObj.subIndx && this.selectedRow.spfIndx === indxObj.spfIndx && this.selectedRow.formIndx === indxObj.chldIndx)) {
            this.selectRow(indxObj.abpIndx, indxObj.prgIndx, indxObj.subIndx, indxObj.spfIndx, indxObj.chldIndx);
        }
    }

    private getNextInputIndx(abpIndx: number, prgIndx: number, subIndx: number, spfIndx: number, chldIndx: number | null) {
        let newSpfIndx = spfIndx;
        let newSubIndx = subIndx;
        let newPrgIndx = prgIndx;
        let newAbpIndx = abpIndx;
        let newChldIndx = null;
        if (this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals.length-1 > spfIndx){
            newSpfIndx++;
        } else {
            if (chldIndx === null && this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals[spfIndx].child_list && this.treeData[abpIndx].vals[prgIndx].vals[subIndx].vals[spfIndx].child_list.length) {
                newChldIndx = 0;
            } else {
                if (this.treeData[abpIndx].vals[prgIndx].vals.length - 1 > subIndx) {
                    newSubIndx++;
                    newSpfIndx = 0;
                } else {
                    if (this.treeData[abpIndx].vals.length - 1 > prgIndx) {
                        newPrgIndx++;
                        newSubIndx = 0;
                        newSpfIndx = 0;
                    } else {
                        if (this.treeData.length - 1 > abpIndx) {
                            newAbpIndx++;
                            newPrgIndx = 0;
                            newSubIndx = 0;
                            newSpfIndx = 0;
                        } else {
                            newAbpIndx = 0;
                            newPrgIndx = 0;
                            newSubIndx = 0;
                            newSpfIndx = 0;
                        }
                    }
                }
            }
        }
        return { abpIndx: newAbpIndx, prgIndx: newPrgIndx, subIndx: newSubIndx, spfIndx: newSpfIndx, chldIndx: newChldIndx };
    }
    // ---------
    private getLocalizedExpenseName(item: any) {
        const lang = this.$i18n.locale; // или из Vuex/i18n
        const fieldName = `expense_name_${lang}`;
        return item[fieldName] || item.expense_name_ru; // fallback
    }
    private inputFocus(event: any) {
        event.target.select();
    }

    // Группа примечаний для строки специфики (chldEl === null) либо проекта в её составе
    private getReasonGroup(spfEl: any, chldEl: any = null): IReasonGroup | null {
        const expenseCode = chldEl ? chldEl.expense_code : null;
        const key = referenceReasonKey(spfEl.abp, spfEl.prg, spfEl.ppr, spfEl.spf, expenseCode, this.reasonPlanType);
        return this.reasonGroups[key] || null;
    }

    // Просмотр примечания (👁 есть в каждой ячейке): без примечания модалка покажет «Примечание не указано»
    private viewReason(spfEl: any, chldEl: any = null) {
        this.$emit('viewReason', this.getReasonGroup(spfEl, chldEl));
    }
}
